import { ArrowUpRight } from "lucide-react";
import { NavLink } from "react-router-dom";

import logo from "../../assets/logo-pharma.png";

export default function Header() {
    return (
        <header className="sticky top-0 z-20 border-b border-border/70 bg-background/90 shadow-sm backdrop-blur-xl">
            <div className="mx-auto flex max-w-7xl items-center px-4 py-2 sm:px-8 sm:py-3">
                <ul
                    className="flex w-full items-center justify-between gap-3 sm:gap-6"
                    aria-label="Navigation principale"
                >
                    <li className="mr-auto shrink-0">
                        <NavLink to="/" end aria-label="Retour à l'accueil">
                            <img
                                src={logo}
                                alt="Pharmagard"
                                className="h-12 w-auto"
                                width="200"
                                height="108"
                            />
                        </NavLink>
                    </li>

                    <li>
                        <a
                            href="https://app.pharmagard.sn/connexion"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-xl bg-primary px-3 py-2.5 text-xs font-semibold text-primary-foreground shadow-sm transition-all hover:-translate-y-0.5 hover:bg-primary/90 hover:shadow-md sm:px-4 sm:text-sm"
                        >
                            Connexion
                            <ArrowUpRight
                                className="h-3.5 w-3.5"
                                aria-hidden="true"
                            />
                        </a>
                    </li>
                </ul>
            </div>
        </header>
    );
}
